export default {
  data() {
    return {
      happyGameData: {
        player1: {
          layers: [],
          currentLayerIndex: 0,
          selectedItem: null,
          completed: false,
          score: 0,
          shake: false,
        },
        player2: {
          layers: [],
          currentLayerIndex: 0,
          selectedItem: null,
          completed: false,
          score: 0,
          shake: false,
        },
      },
    };
  },
  methods: {
    initHappyGame() {
      this.initPlayerHappyData("player1");
      this.initPlayerHappyData("player2");
      this.gameState = "playing";
      this.optionsPanelVisible = false;
    },

    initPlayerHappyData(playerKey) {
      this.happyGameData[playerKey] = {
        layers: [],
        currentLayerIndex: 0,
        selectedItem: null,
        completed: false,
        score: 0,
        shake: false,
      };

      // Use questionCount to limit vocabulary
      let sourceVocab = [...this.vocabulary];
      sourceVocab.sort(() => 0.5 - Math.random());
      let selectedPairs = sourceVocab.slice(0, Math.min(this.questionCount, sourceVocab.length));

      const pairsPerLayer = 6;
      const numLayers = Math.ceil(selectedPairs.length / pairsPerLayer);

      for (let i = 0; i < numLayers; i++) {
        const layerPairs = selectedPairs.slice(i * pairsPerLayer, (i + 1) * pairsPerLayer);
        const layerItems = [];

        layerPairs.forEach((pair, index) => {
          layerItems.push({
            id: `layer-${i}-pair-${index}-en`,
            content: pair.english,
            pairId: pair.english,
            type: "english",
            status: "normal",
          });

          layerItems.push({
            id: `layer-${i}-pair-${index}-cn`,
            content: pair.chinese,
            pairId: pair.english,
            type: "chinese",
            status: "normal",
          });
        });

        layerItems.sort(() => 0.5 - Math.random());
        this.happyGameData[playerKey].layers.push(layerItems);
      }
    },
    handleHappyTouchSelect(player, item, optionIndex, event) {
      // 阻止默认行为和事件冒泡，确保双方独立
      if (event) {
        event.preventDefault();
        event.stopPropagation();
      }
      this.handleHappyItemClick(player, item, optionIndex);
    },
    handleHappyItemClick(playerKey, item, index) {
      const playerData = this.happyGameData[playerKey];

      if (playerData.completed || item.status === "matched" || item.status === "error") {
        return;
      }

      if (item.status === "selected") {
        item.status = "normal";
        playerData.selectedItem = null;
        return;
      }

      if (!playerData.selectedItem) {
        item.status = "selected";
        playerData.selectedItem = { item, index };
      } else {
        const prevSelection = playerData.selectedItem;
        const prevItem = prevSelection.item;

        if (prevItem.pairId === item.pairId) {
          item.status = "matched";
          prevItem.status = "matched";
          playerData.selectedItem = null;
          playerData.score += 1;
          if (playerKey === "player1") this.player1Score = playerData.score;
          if (playerKey === "player2") this.player2Score = playerData.score;
          this.playAnswerFeedback(true);

          this.checkLayerClear(playerKey);
        } else {
          item.status = "error";
          prevItem.status = "error";
          playerData.selectedItem = null;
          this.playAnswerFeedback(false);

          setTimeout(() => {
            if (item.status === "error") item.status = "normal";
            if (prevItem.status === "error") prevItem.status = "normal";
          }, 500);
        }
      }
    },

    checkLayerClear(playerKey) {
      const playerData = this.happyGameData[playerKey];
      const currentLayer = playerData.layers[playerData.currentLayerIndex];

      const allMatched = currentLayer.every((item) => item.status === "matched");

      if (allMatched) {
        setTimeout(() => {
          playerData.currentLayerIndex++;
          if (playerData.currentLayerIndex >= playerData.layers.length) {
            playerData.completed = true;
            if (playerKey === "player1") this.player1Completed = true;
            if (playerKey === "player2") this.player2Completed = true;
            this.endGame();
          }
        }, 300);
      }
    },
  },
};
